import React from "react"
import { css, jsx } from "@emotion/core"

class MainWrapper extends React.Component {
  render() {
    return (
      <article
        css={{
          "@media(min-width: 1300px)": {
            float: "left",
            width: "100%",
          },
        }}
      >
        <div
          css={{
            "@media(min-width: 1300px)": {
              marginRight: "400px",
            },
            clear: "both",
            overflow: "auto",
            minHheight: "600px",
            backgroundColor: "#fff",
            padding: "25px",
            boxShadow: " 0px 2px 9px -4px #383838",
          }}
        >
          {this.props.children}
        </div>
      </article>
    )
  }
}

export default MainWrapper
